import type { FaireProductEntity } from "../../entity_types/product";

export const p_zr2yewrbek: FaireProductEntity = {
  token: "p_zr2yewrbek",
  type: "product",
  name: "Ceramic Vase, Pasta Box",
  brandToken: "b_2io333ig7s",
  brandName: "Ban.do",
  imageUrl: "https://cdn.faire.com/fastly/ce18629c556c0d233a326767f4b46e060c8ecaaa9553f86a12f49d6f208cd745.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4798a23c0559d226190ed4d3ba85c802e9900ca4230cf2a7115fcbf63348c9d9.jpeg",
    "https://cdn.faire.com/fastly/89c45d1e4ba5ac933542258dee38a4dde448df71ca2bb274a452b0b8a9649c63.jpeg",
    "https://cdn.faire.com/fastly/39facb988754e6c73f1d1ae296cc11d26136386c728df1885821243d1627c75d.jpeg",
    "https://cdn.faire.com/fastly/b8121da9cd25f7d1d13919a88f9a09524f7f46f1166d10e82003c630b60f35d5.jpeg",
    "https://cdn.faire.com/fastly/65344f77cb963a073103ea4cf8bb95fe3a96908f2e3c42e37306659e13f82a8d.jpeg",
    "https://cdn.faire.com/fastly/c3270639dc495bfb61552b6b64d6572a1e70d108665f99ecde8bfbdac53d3235.jpeg",
    "https://cdn.faire.com/fastly/b5d26defa43974e2697c8c5cde31f6b23c565f088614dec5cac73abf4af9a99f.jpeg",
    "https://cdn.faire.com/fastly/050bf5fdd2c6dc4b033489f810a7023bc1404350fe08ea134d0c337b9c574605.jpeg",
    "https://cdn.faire.com/fastly/115b7804b4bbce42ce2bc190a356f8260898f275210820dc89b6ece7cb79c2d5.jpeg",
    "https://cdn.faire.com/fastly/08d3bcaf50a41f192e82e8e81b89def000cc54e46a99101d5471b65a081141bd.jpeg",
    "https://cdn.faire.com/fastly/4e18a436e0d8cba475b5fc2e71be8a5c2769ef996546e255e30da4f52f9f719a.jpeg",
    "https://cdn.faire.com/fastly/e9bb85df9bc5c982a3612abf796c94abf5e8360225564f80a8c34ef6e7b65e5a.jpeg"
  ],
  priceDollars: 14,
  description: "This ceramic vase is best enjoyed surrounded by olive oil, bread, and loved ones. Place some flowers or dried stems in it, and enjoy! You could also mix in a few spaghetti or fettuccine noodles as well. Just an idea we're workshopping.\n\nFeatures:\nCeramic vase with a playful, pasta-inspired concept\nPerfect for fresh flowers, dried stems, or creative styling moments\nAdds a fun, food-themed touch to kitchen or dining décor\nDurable and easy to display on tables, shelves, or countertops\nDesigned in Bando’s signature bright and whimsical style\n\n\nIdeal For:\nGift shops and home décor boutiques\nKitchenware and lifestyle retailers\nSpecialty food shops and Italian-inspired boutiques\nWholesale buyers seeking quirky, conversation-starting home décor",
  tags: [],
  msrpDollars: 28.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:32:16.590Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
